import Alpine from "alpinejs";

/**
 * Toggle the class passed as expression for all children of the parent with the same data-id attribute value.
 * @param el Element with the attribute
 * @param expression Class to add/remove on mouse enter/mouse leave
 * @param cleanup Function used to remove event handler
 */
const activate: Alpine.DirectiveCallback = (el, _, { cleanup }) => {
  function onActivate() {
    el.classList.add("active");
  }

  function onDeactivate() {
    el.classList.remove("active");
  }

  el.addEventListener("mousedown", onActivate);
  el.addEventListener("mouseup", onDeactivate);
  el.addEventListener("deactivate", onDeactivate);

  cleanup(() => {
    el.removeEventListener("mousedown", onActivate);
    el.removeEventListener("mouseup", onDeactivate);
    el.removeEventListener("deactivate", onDeactivate);
  });
};

export default activate;
